import { types } from '../actions/types';

export const BannerReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.bnrGetBanners:
      return { ...state, get: action.payload };
    case types.bnrCreateBanner:
      return { ...state, create: action.payload };
    case types.bnrUpdateBanner:
      return { ...state, update: action.payload };
    case types.bnrDeleteBannerById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
